module.exports = {"320612001":"金沙街道","320612002":"兴东街道","320612003":"先锋街道","320612004":"金新街道","320612101":"西亭镇","320612102":"二甲镇","320612103":"东社镇","320612104":"三余镇","320612107":"十总镇","320612110":"石港镇","320612112":"刘桥镇","320612114":"平潮镇","320612116":"五接镇","320612117":"兴仁镇","320612119":"张芝山镇","320612120":"川姜镇","320612401":"环本农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320612.json
// module id = 811
// module chunks = 0